import * as React from 'react';

import { Grid,  Button } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect, Provider } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService, KarnetDoladowania, KarnetService, KarnetZjazdy } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import TabelaDoladowania from './TabelaDoladowania';
import { NoResult }  from 'components/NoResult';
import Pagination, { calculateRange } from 'components/Pagination';
import LoaderNoWindow from 'components/LoaderNoWindow';
import { sendErrorLog } from 'common/helpers';
import ReactDOM from 'react-dom';
import DialogDoladowaniaInfo from './DialogDoladowaniaInfo';

interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {
  paginacja: number[],
  loading: boolean
}

class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      paginacja: [0, 1, 10],
      loading: false
    }
  }

  componentDidMount() {
    sendErrorLog("1", "1", 'historia doladowan')
    this.getTabela()
  }

  componentDidUpdate(prevProps: DoladujKarnetProps) {
    if (prevProps.page.refresh !== this.props.page.refresh) {
      this.getTabela()
    }
   
  }

  getTabela = async () => {
    try {
      this.setState({loading: true})
      let res: Result<KarnetDoladowania> = await KarnetService.dajKarnetDoladowania({ parametry: { hotelId: CONFIG.hotelId, operatorId: "1", karnetEkarta: this.props.page.karnet.ekarta } })
      store.dispatch(Actions.pageState.setKarnetDoladowania(res.result))
      this.setState({loading: false})
      //console.log(res)
    } catch (error) {
      console.error()
      sendErrorLog("0", "-1", '/karnet/dajKarnetDoladowania')
      store.dispatch(Actions.pageState.addFcmLogMessage("/karnet/dajKarnetDoladowania", 2))
    }
    

    // let tabela = [
    //   {
    //     data: "2024-11-19 09:15",
    //     opis: "zjazdy za - 55 pln",
    // },
    // {
    //     data: "2024-11-19 11:25",
    //     opis: "zjazdy za - 55 pln",
    // },
    // {
    //     data: "2024-11-19 17:10",
    //     opis: "godz 17-20 - 50 pln",
    // },
    //]

    

  }

  openInfo = (cell: KarnetDoladowania) => {

    let num : number = Math.random()
    ReactDOM.render(
        <Provider store={store}>
          <MuiThemeProvider theme={theme}>
            <DialogDoladowaniaInfo randomNum={num}  doladowanie={cell}
            />
          </MuiThemeProvider>
        </Provider>, document.getElementById("dialog"))

  }

  updateSkip = async (aPage: number) => {
    const newSkip = (aPage - 1) * this.state.paginacja[2]
    this.setState({ paginacja: [newSkip, aPage, this.state.paginacja[2]] })
  }
  changeRowsPerPage = async (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    this.setState({ paginacja: [0, 1, Number(event.target.value)] })
  }

  
  render() {
    const { classes, t } = this.props;

    let ilosc = this.props.page.karnetDoladowania.length
    const range = calculateRange(ilosc, this.state.paginacja[2])
    
    let tabela: KarnetDoladowania[] = this.props.page.karnetDoladowania;
    tabela = tabela.slice(this.state.paginacja[0], this.state.paginacja[0] + this.state.paginacja[2]) 
    let tablet = this.props.page.tablet

      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} style={{maxWidth: tablet ? "450px" : "370px", margin: "auto", paddingLeft: 0, paddingRight: 0}}>
                 
              { this.state.loading? 
              <LoaderNoWindow/> :
                tabela.length === 0 ?
                  <NoResult text={'Czekamy na Twoje doładowania'}/> :
                  <>
                    <TabelaDoladowania
                      tableBody={tabela}
                      icon
                      select={this.openInfo}
                      />

                  <Pagination
                    page={this.state.paginacja[1]}
                    range={range}
                    updateSkip={this.updateSkip}
                    changeResultsPerPage={this.changeRowsPerPage}
                    resultsPerPage={this.state.paginacja[2]}
                    tableLength={ilosc}
                  />


                  </>}


              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
    container1: {
        //margin: "0em",
        //paddingTop: "0.4em",
        margin: "12px auto 0px",
        padding: '0em 0em',
        minHeight: "100%",
        maxWidth: "1340px",
        //border: "2px solid lavender"
      },
      gridItem: {
        minHeight: "150px",
      },
      
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

